import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import Card from '../../components/card';
import { TextField } from '../../components/MaskedTextField';
import hubspot from '../../modules/hubspot';
import parseName from '../../modules/parse-name';
import styles from '../../styles/form';

export const nameValidator = (name) => {
  const { first, last } = parseName(name);
  return !!(first && last);
};

const style = Object.assign(
  {
    row: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  styles
);

export const ContactInfo = ({ model, scenario, onChange, onSubmit, ...cardProps }) => (
  <Card
    completeText="SUBMIT MY INFORMATION"
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.identifyContact(model.get('email'));
        onSubmit();
      })
    }
    {...cardProps}
  >
    <TextField
      className="private"
      value={model.get('name')}
      style={style.threeQuarters}
      floatingLabelText="Full Name"
      onChange={onChange.bind(null, 'name')}
      validate={(value) => {
        return !nameValidator(value) ? 'Please enter both first and last name' : '';
      }}
    />
    <br />
    <TextField
      className="private"
      value={model.get('email')}
      style={style.threeQuarters}
      validate={(value) => {
        return !emailValidator.validate(value) ? 'Please enter a valid email' : '';
      }}
      floatingLabelText="Email Address"
      onChange={(v) => onChange('email', v.trim())}
    />
  </Card>
);



// WEBPACK FOOTER //
// ./src/cards/contact-info-short/index.js